import { HiddenField } from 'uniforms-bootstrap3';

export const BaseSchema = {
	updatedAt: {
		type: Date,
		label: "Date de dernière modification",
		uniforms: HiddenField,
		optional: true,
		hide: true,
		autoValue: function() {
			return new Date();
		}
	},
	createdAt: {
		type: Date,
		label: "Date de création",
		uniforms: HiddenField,
		optional: true,
		autoValue: function() {
			if (this.isInsert) {
				return new Date();
			} else if (this.isUpsert) {
				return {$setOnInsert: new Date()};
			} else {
				//this.unset();  // Prevent user from supplying their own value
			}
		}
	},
};



/** WEBPACK FOOTER **
 ** ./src/universal/collections/baseSchema.js
 **/